import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { breakpoints } from '@avangard/ui/utils';
import { TextField } from '@avangard/ui/core';

import { FormStyled } from '@modules/layout/styled';

import type { SchoolEntity } from '@modules/schools/entities';

type SchoolCommonInfoProps = {
    school: SchoolEntity;
};

const Root = styled.div`
    display: flex;
    flex-direction: column;

    & > *:not(:last-child) {
        margin-block-end: 24px;
    }
`;

const Row = styled(FormStyled.FormRow)`
    align-items: flex-start;

    > * {
        width: calc(50% - 10px);

        &:first-child {
            position: relative;
            margin-inline-end: 20px;
        }

        ${breakpoints.down('xs')} {
            width: 100%;

            &:first-child {
                position: relative;
                margin-inline-end: 0;
                margin-block-end: 20px;
            }
        }
    }
`;

const SchoolCommonInfo = (props: SchoolCommonInfoProps): React.ReactElement => {
    const { school } = props;

    const { t } = useTranslation('common');

    return (
        <Root>
            <FormStyled.FormColumnTitle>
                {t('common:form.titles.summary')}
            </FormStyled.FormColumnTitle>

            <Row>
                <TextField
                    disabled
                    label={t('common:form.labels.region') ?? ''}
                    value={school.region.name}
                />
                <TextField
                    disabled
                    label={t('common:form.labels.location') ?? ''}
                    value={school.location.name}
                />
            </Row>

            <Row>
                <TextField
                    disabled
                    label={t('common:form.labels.school_type') ?? ''}
                    value={school.getHumanSchoolType()}
                />
                <TextField
                    disabled
                    label={t('common:form.labels.school_short_name') ?? ''}
                    value={school.shortName}
                />
            </Row>
        </Root>
    );
};

export { SchoolCommonInfo };
